export default {
  'pages.layouts.userLayout.title': '顾客至上、事业服务、合理收费',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名或密码',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '已启用',
  'pages.searchTable.nameStatus.success': '已租/售出',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  'pages.userTable.nickname': '昵称',
  'pages.userTable.username': '用戶名',
  'pages.userTable.remarks': '备注',
  'pages.userTable.status': '是否启用',
  'pages.userTable.updatedAt': '更新时间',
  'pages.userTable.updater': '更新人',
  'pages.userTable.action': '操作',
  'pages.userTable.password': '密码',
  'pages.userTable.roles': '权限角色',
  'pages.userTable.createUser': '创建账号',

  'pages.userTable.create.username': '用户名不能为空',
  'pages.userTable.create.password': '请输入最少六位数的密码',

  'pages.userTable.resetPassword': '重置密码',
  'pages.userTable.isResetPassword': '是否确定重置密码?',
  'pages.userTable.isResetPasswordDescription': '请确认是否重置密码，重置后密码为“123456”。',
  'pages.userTable.updateUser': '更新账号信息',

  'pages.setting.password': '修改密码',
  'pages.setting.reset.password.required': '请输入最少六位的密码',
  'pages.setting.password.confirm': '请确认密码',
  'pages.setting.password.confirm.placeholder': '请重新输入密码',
  'pages.setting.password.two': '请确认两次密码输入一致',

  'pages.roleTable.name': '角色名称',
  'pages.roleTable.description': '角色说明',
  'pages.roleTable.updatedAt': '更新时间',
  'pages.roleTable.createRole': '新建角色',
  'pages.roleTable.create.name': '角色名称不能为空',
  'pages.roleTable.permission': '角色权限',
  'pages.roleTable.update.title': '更新角色',

  'pages.districtTable.images': '小区图片',
  'pages.districtTable.name': '小区名称',
  'pages.districtTable.address': '小区所在地',
  'pages.districtTable.description': '小区介绍',
  'pages.districtTable.facilities': '環境設施',
  'pages.districtTable.livingTransport': '生活交通',
  'pages.districtTable.school': '学校网络',
  'pages.districtTable.securityManagement': '治安管理',
  'pages.districtTable.isShow': '是否在官网上显示小区介绍',
  'pages.districtTable.title': '小区管理',
  'pages.districtTable.create.district': '新建小区',
  'pages.districtTable.address.placeholder': '点击右侧按钮，选择小区所在地',
  'pages.districtTable.create.address.required': '请选择小区所在地',
  'pages.districtTable.create.name': '请填写小区所在地',
  'pages.districtTable.nameStatus.show': '显示',
  'pages.districtTable.nameStatus.noShow': '不显示',
  'pages.districtTable.update.district':"更新屋苑",

  'pages.houseTable.update.house':"更新盘口",
  'pages.houseTable.images': '盘口图片',
  'pages.houseTable.name': '盘口名称',
  'pages.houseTable.address': '盘口位置',
  'pages.houseTable.description': '盘口介绍',
  'pages.houseTable.type': '盘口类型',
  'pages.houseTable.nameStatus.gy': '公寓',
  'pages.houseTable.nameStatus.hz': '豪宅',
  'pages.houseTable.nameStatus.jw': '居屋',
  'pages.houseTable.nameStatus.cw': '村屋',
  'pages.houseTable.nameStatus.dw': '丁屋',
  'pages.houseTable.nameStatus.fw': '服务式公寓',
  'pages.houseTable.nameStatus.tl': '唐楼',
  'pages.houseTable.peddleType': '租售类型',
  'pages.houseTable.nameStatus.sell': '出售',
  'pages.houseTable.nameStatus.hire': '出租',
  'pages.houseTable.status': '状态',
  'pages.houseTable.nameStatus.shelves': '上架中',
  'pages.houseTable.nameStatus.done': '已租/售出',
  'pages.houseTable.nameStatus.staging': '暂存',
  'pages.houseTable.prices': '价格(港币)',
  'pages.houseTable.roomsNumber': '房价数量',
  'pages.houseTable.toiletsNumber': '厅数量',
  'pages.houseTable.size': '实用面积(平方英尺)',

  'pages.houseTable.areaSize': '建筑面积(平方英尺)',
  'pages.houseTable.create.areaSize': '请填写盘口建筑面积',

  'pages.houseTable.isRecommend': '是否在首页上进行推荐',
  'pages.houseTable.nameStatus.no': '否',
  'pages.houseTable.nameStatus.yes': '是',
  'pages.houseTable.shelveTime': '盘口上架时间',
  'pages.houseTable.completeContractTime': '盘口完成交易时间',
  'pages.houseTable.title': '盘口管理',
  'pages.houseTable.dealPrice': '成交价（仅在售出状态显示）',
  'pages.houseTable.dealTime': '成交时间',

  'pages.houseTable.district': '所属小区',
  'pages.houseTable.create.house': '新建盘口',
  'pages.houseTable.create.peddleType': '请选择租售类型',
  'pages.houseTable.create.address.required': '请选择盘口位置',
  'pages.houseTable.create.name': '盘口名称不能为空',
  'pages.houseTable.create.type': '请选择盘口类型',
  'pages.houseTable.create.status': '请选择盘口状态',
  'pages.houseTable.create.prices': '请填写租售价格',
  'pages.houseTable.create.roomsNumber': '请填写房间数量',
  'pages.houseTable.create.toiletsNumber': '请填写厅数量',
  'pages.houseTable.create.size': '请填写盘口实用面积',
  'pages.houseTable.description.color': '盘口描述显示的颜色',
  'pages.houseTable.address.placeholder': '请选择位置',

  'pages.feedbackTable.name': "客户姓名",
  'pages.feedbackTable.phoneNumber': "手机号码",
  "pages.feedbackTable.email": "电子邮件",
  "pages.feedbackTable.description": "客户需求",
  "pages.feedbackTable.status": "是否已处理",
  "pages.feedbackTable.nameStatus.yes": "已处理",
  "pages.feedbackTable.nameStatus.no": "未处理",
  "pages.feedbackTable.title": "留言管理",
  "pages.feedbackTable.remark": "备注",
  "pages.feedbackTable.createdAt": "提交时间",
  "pages.feedbackTable.action": "处理",
  'pages.feedbackTable.update.title':'处理留言',

  'pages.global.delete': '删除',
  'pages.global.remarks': '备注',
  'pages.global.nameStatus.show': '显示',
  'pages.global.nameStatus.noShow': '不显示',
  'pages.global.updatedAt': '更新时间',
  'pages.global.updater': '更新人',
  'pages.global.update': '更新',
  'pages.global.isDelete': '是否确认删除',
  'pages.global.isDeleteDescription': '是否确定删除数据？删除后将不可恢复。',
  'pages.global.selectLocation': '选择位置',
  'pages.global.location.required': '请点击地图选择位置',
  'pages.global.select.clickMap': '点击地图选择位置',
  'pages.global.select': '选择',
};
